/**
 * LISTADO DE ENDPOINTS API GESTIÓN DE PARTES  https://apigestionpartesdev.azurewebsites.net
 */
const URL_API_GESTION_PARTES = {
    /**
     * GuardarDatosUsuarios ENDPOINT de la API de Gestión de Partes
     * Método: POST
     * Descripción: Permite guardar los datos de un usuario.
     */
    GUARDAR_DATOS_USUARIOS: `${import.meta.env.VITE_API_GESTION_PARTES}/api/Contactos/GuardarDatosUsuarios`,
    
    /**
     * GuardarDatosUsuariosV2 ENDPOINT de la API de Gestión de Partes
     * Método: POST
     * Descripción: Permite guardar los datos de un usuario.
     */
    GUARDAR_DATOS_USUARIOSV2: `${import.meta.env.VITE_API_GESTION_PARTES}/api/Contactos/GuardarDatosUsuariosV2`,

    /**
     * GuardarMiembroEntidad ENDPOINT de la API de Gestión de Partes
     * Método: POST
     * Descripción: Permite guardar un nuevo miembro para una entidad.
     */
    GUARDAR_MIEMBRO_ENTIDAD: `${import.meta.env.VITE_API_GESTION_PARTES}/api/Contactos/GuardarMiembroEntidad`,

    /**
     * EditarMiembroEntidad ENDPOINT de la API de Gestión de Partes
     * Método: PUT
     * Descripción: Permite editar los datos de un miembro de una entidad.
     */
    EDITAR_MIEMBRO_ENTIDAD: `${import.meta.env.VITE_API_GESTION_PARTES}/api/Contactos/EditarMiembroEntidad`,

    /**
     * EliminarMiembroEntidad ENDPOINT de la API de Gestión de Partes
     * Método: PUT
     * Descripción: Permite eliminar lógicamente un miembro de una entidad.
     */
    ELIMINAR_MIEMBRO_ENTIDAD: `${import.meta.env.VITE_API_GESTION_PARTES}/api/Contactos/EliminarMiembroEntidad`,

    /**
     * AgregarParte ENDPOINT de la API de Gestión de Partes
     * Método: POST
     * Descripción: Permite agregar una nueva parte (persona o empresa) a un caso.
     */
    AGREGAR_PARTE: `${import.meta.env.VITE_API_GESTION_PARTES}/api/Partes/AgregarParte`,
    /**
     * AgregarParte ENDPOINT de la API de Gestión de Partes
     * Método: POST
     * Descripción: Permite agregar una nueva parte (persona o empresa) a un caso.
     */
    HANDLE_PART: `${import.meta.env.VITE_API_GESTION_PARTES}/api/Partes/v2/GestionarParte`,

    /**
     * AgregarPartesDesdeTramiteExistente ENDPOINT de la API de Gestión de Partes
     * Método: POST
     * Descripción: Agrega partes a un trámite nuevo a partir de las partes de un trámite existente.
     */
    AGREGAR_PARTES_DESDE_TRAMITE_EXISTENTE: `${import.meta.env.VITE_API_GESTION_PARTES}/api/Partes/AgregarPartesDesdeTramiteExistente`,

    /**
     * EditarParte ENDPOINT de la API de Gestión de Partes
     * Método: PUT
     * Descripción: Edita la información de una parte existente.
     */
    EDITAR_PARTE: `${import.meta.env.VITE_API_GESTION_PARTES}/api/Partes/EditarParte`,

    /**
     * EliminarParte ENDPOINT de la API de Gestión de Partes
     * Método: DELETE
     * Descripción: Elimina lógicamente una parte de un caso o trámite.
     * @example: `${import.meta.env.VITE_API_GESTION_PARTES}/api/Partes/v2/RemoverParte?idTramite=12&idTramiteParteRepresentante=123&tipoInvolucramiento=1234`
     */
    REMOVE_PART: `${import.meta.env.VITE_API_GESTION_PARTES}/api/Partes/v2/RemoverParte`,

    /**
     * GestionarPartesORepresentantesEnLote ENDPOINT de la API de Gestión de Partes
     * Método: POST
     * Descripción: Gestiona (agrega/edita) partes o representantes en un proceso por lote, con parámetros de consulta para idTramite e idCaso.
     */
    GESTIONAR_PARTES_O_REPRESENTANTES_EN_LOTE: `${import.meta.env.VITE_API_GESTION_PARTES}/api/Partes/GestionarPartesORepresentantesEnLote`,

    /**
     * ObtenerPersona ENDPOINT de la API de Gestión de Partes
     * Método: GET
     * Descripción: Obtiene la información de una persona por su identificación, nombre o tipo de identificación.
     */
    OBTENER_PERSONA: `${import.meta.env.VITE_API_GESTION_PARTES}/api/Partes/ObtenerPersona`,

    /**
     * ObtenerEntidad ENDPOINT de la API de Gestión de Partes
     * Método: GET
     * Descripción: Obtiene la información de una entidad por su identificación, nombre o tipo de identificación.
     */
    OBTENER_ENTIDAD: `${import.meta.env.VITE_API_GESTION_PARTES}/api/Partes/ObtenerEntidad`,
};

export default URL_API_GESTION_PARTES;